module.exports = __webpack_public_path__ + "static/media/ico-home.fe68c4dc.svg";